import React, { FunctionComponent, SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Dropdown from '../../../../../../../../App/Components/Dropdown/Dropdown'
import DateFormats from '../../../../../../../../App/Helpers/DateFormats'
import style from '../../../../style.scss'

import { IProps } from './IProps'

export const TimeSummary: FunctionComponent<IProps> = ({
    date,
    setDate,
    setHasDate,
}) => {
    const { t } = useTranslation()

    const onHourSelect = (e: SyntheticEvent<HTMLSelectElement>) => {
        setDate(date.clone().hours(parseInt(e.currentTarget.value, 10)))
    }

    const onMinutesSelect = (e: SyntheticEvent<HTMLSelectElement>) => {
        setDate(date.clone().minutes(parseInt(e.currentTarget.value, 10)))
    }

    if (!date) {
        return (
            <div className={style.date} onClick={() => setHasDate(undefined)}>
                {t('No date selected')}
                <FontAwesomeIcon
                    icon={faPencilAlt}
                    className={style.editIcon}
                />
            </div>
        )
    }

    return (
        <>
            <div
                className={style.date}
                onClick={() => {
                    setDate(undefined)
                    setHasDate(undefined)
                }}
            >
                {date.format(DateFormats.DATE_FORMAT_FULL)}
                <FontAwesomeIcon
                    icon={faPencilAlt}
                    className={style.editIcon}
                />
            </div>

            <div>
                <Dropdown
                    label={t('Time')}
                    className={style.dropdownInline}
                    value={date.format('HH')}
                    onChange={(e: SyntheticEvent<HTMLSelectElement>) =>
                        onHourSelect(e)
                    }
                >
                    {Array(24)
                        .fill(0)
                        .map((_, index) => (
                            <option>{index.toString().padStart(2, '0')}</option>
                        ))}
                </Dropdown>
                :
                <Dropdown
                    className={style.dropdownInline}
                    value={date.format('mm')}
                    onChange={(e: SyntheticEvent<HTMLSelectElement>) =>
                        onMinutesSelect(e)
                    }
                >
                    {Array(60 / 5)
                        .fill(0)
                        .map((_, index) => (
                            <option>
                                {(index * 5).toString().padStart(2, '0')}
                            </option>
                        ))}
                </Dropdown>
            </div>
        </>
    )
}
